import { Routing } from '@/pages';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { CssBaseline } from '@mui/material';
import { MuiProvider } from './providers/mui-provider';
import { Provider } from 'react-redux';
import { store } from './store';
import { NotificationProvider } from '@/shared/contexts/NotificationContext';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ruRU } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/ru';
import 'dayjs/locale/uz';
import 'dayjs/locale/uz-latn';
import { TelegramBtn } from '@/shared/telegram-btn';
import { useLayoutEffect } from 'react';
import { eimzo } from '@/entities/eimzo';
import { uzUZCyrlPickers } from './i18n/time-views/uz_cyrl';
import { uzUZLatinPickers } from './i18n/time-views/uz_latn';
import dayjs from 'dayjs';
import { DateRangeProvider } from './providers/date-range-provider';

function App() {
  const lang = (localStorage.getItem('lang') || 'ru') as
    | 'ru'
    | 'uz_cyrl'
    | 'uz_latn';
  const dayjsLangs = {
    ru: 'ru',
    uz_cyrl: 'uz',
    uz_latn: 'uz-latn',
  };

  useLayoutEffect(() => {
    eimzo.startApi();

    dayjs.locale(dayjsLangs[lang]);
  }, []);

  const localTexts = {
    ru: ruRU.components.MuiLocalizationProvider.defaultProps.localeText,
    uz_cyrl: uzUZCyrlPickers,
    uz_latn: uzUZLatinPickers,
  };

  return (
    <I18nextProvider i18n={i18n}>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={dayjsLangs[lang]}
        localeText={localTexts[lang]}
      >
        <DateRangeProvider locale={lang}>
          <Provider store={store}>
            <MuiProvider>
              <NotificationProvider>
                <CssBaseline />
                <Routing />
                <TelegramBtn />
              </NotificationProvider>
            </MuiProvider>
          </Provider>
        </DateRangeProvider>
      </LocalizationProvider>
    </I18nextProvider>
  );
}

export default App;
